import BaseResource from './index'
import LookingForResource from './lookingfor'
import MetroAreaResource from './metroarea'
import SkillResource from './skill'
import RoleResource from './role'
import UserResource from './user'
import ImageResource from './image'
import ExperienceResource from './experience'
import EducationResource from './education'

export default class DeveloperProfileResource extends BaseResource {
    static endpoint = '/profiles'

    static related() {
        return {
            user: UserResource,
            image: ImageResource,
            location_preferred: MetroAreaResource,
            locations_open_to: MetroAreaResource,
            primary_role: RoleResource,
            secondary_roles: RoleResource,
            skills: SkillResource,
            looking_for: LookingForResource,
            experience: ExperienceResource,
            education: EducationResource,
        }
    }

    static defaults = {
        education: [],
        experience: [],
        skills: [],
        looking_for: [],
        secondary_roles: [],
        applications: [],
        locations_open_to: []
    }

    static async random() {
        let endoint = this.wrap('/random')
        let result = await endoint.get()
        return new DeveloperProfileResource(result.data)
    }

    workedAt() {
        if (!this.readonly.experience_latest_names) {
            return null
        }

        return this.readonly.experience_latest_names.join(', ')
    }

    salaryFormatted() {
        let value = this.attributes.salary
        
        if (value && value.length > 1) {
            if ('object' === typeof Intl) {
                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0
                })

                return formatter.format(value)
            } else {
                return '$' + Number(value).toFixed(2)
            }
        }

        return 'Flexible'
    }

    getExperienceResourcesSorted() {
        let manager = this.rel('experience')
        let resources = [].concat(manager.resources)

        return resources.sort((resourceA, resourceB) => {
            if(!resourceB.attributes.end_year) {
                return 1000
            }

            return resourceB.attributes.end_year - resourceA.attributes.end_year
        })
    }

    getEducationResourcesSorted() {
        let manager = this.rel('education')
        let resources = [].concat(manager.resources)

        return resources
    }
    
    hasEliteEducation() {
        let edus = this.rel('education').resources
        for(let education of edus) {
            if(education.isElite()) {
                return true
            }
        }

        return false
    }

    toString() {
        return [this.readonly.first_name, this.readonly.last_name].filter((nameBit) => !!nameBit).join(' ')
    }
}
